<template>
  <handTime/>
</template>

<script>
import handTime from '@/components/calendar/appoDate';
export default {
	components: {
		handTime
	}
}
</script>

<style scoped>

</style>